<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="container-fluid w-100 pb-3" style="overflow: hidden">
        <navbar :title="$t('menu.external_ids')"/>
      <div class="col-sm-12">
        <div class="col-12 d-flex justify-content-end my-2">
          <button class="btn btn-sm btn-success form-button" @click.stop="addNew()">
            {{ $t('common.add_new') }}
          </button>
        </div>
        <div class="col-12 nopads list-container">
            <div v-if="results.length > 0" class="col-sm-12 list-content result-table">
                <vue3-datatable
                    ref="resultTable"
                    :rows="results"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    height="100%"
                    :sortable="true"
                    skin="bh-table-compact"
                    row-class="routa-table-row"
                    cell-class="routa-table-cell"
                    @row-click="editItem"
                >
                    <template #company="row">
                        {{ row.value.company.name }}
                    </template>
                    <template #external_system="row">
                        Velho
                    </template>
                    <template #inactive="row">
                        {{ row.value.inactive ? $t('common.no') : $t('common.yes') }}
                    </template>
                </vue3-datatable>

            </div>
        </div>
      </div>
      <base-modal v-if="selectedItem" hide-header hide-footer @close="selectedItem = null">
          <external-contract-id-editor
            :record="selectedItem"
            @close="selectedItem = null"
            @close-and-update="fetchData"
          />
      </base-modal>
  </div>
</template>

<script>
import {restApi} from "@/components/mixins/RestApiMixin";
import ExternalContractIdEditor from "@/components/contract/external/ExternalContractIdEditor";
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'ExternalContractIds',
    components: {BaseModal, Navbar, ExternalContractIdEditor, Vue3Datatable},
    mixins: [restApi],
    data() {
        return {
            results: [],
            fields: [
                {field: 'id', title: 'Id', sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'company', title: this.$t('users.company'), sort: true, headerClass: 'routa-table-header'},
                {field: 'external_name', title: this.$t('contracts.name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'external_id', title: this.$t('contracts.number'), sort: true, headerClass: 'routa-table-header'},
                {field: 'external_system', title: this.$t('contracts.customer'), sort: true, headerClass: 'routa-table-header'},
                {field: 'inactive', title: this.$t('common.in_use'), sort: true, headerClass: 'routa-table-header'},
            ],
            loading: false,
            selectedItem: null
        }
    },
    mounted: function () {
        this.fetchData()
    },
    methods: {
        fetchData() {
            this.results = []
            this.loading = true
            this.selectedItem = null
            this.restFetch(this.extContractIdUrl, this.handleResponse)
        },
        handleResponse(response) {
            this.loading = false
            if (response && response.data) {
                this.results = response.data
            }
        },
        editItem(item) {
            this.selectedItem = item
        },
        addNew() {
            this.selectedItem = {
                id: -1,
                company: null,
                external_id: null,
                external_system: 1,
                external_name: null,
                inactive: false
            }
        }
    }
}
</script>
